<script setup lang="ts">
import { useRoute } from 'vue-router';

export interface Props {
  paramTitle?: string;
  paramValue?: string;
  isValue?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  paramTitle: undefined,
  paramValue: undefined,
  isValue: undefined,
});

const route = useRoute();
</script>

<template>
  <v-chip
    v-if="props.paramTitle && (route.query[props.paramTitle] || props.isValue)"
    :rounded="0"
    data-testid="requestChip"
    :class="$style.requestChip"
  >
    <slot></slot>
    <router-link
      :style="{ height: '18px' }"
      :to="{ query: { ...route.query, [props.paramTitle]: props.paramValue } }"
      class="v-chip__close"
    >
      <v-icon icon="mdi-close-circle"></v-icon>
    </router-link>
  </v-chip>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.requestChip {
  --v-chip-height: 28px !important;
  padding: 0 8px !important;

  :global {
    .v-chip__close {
      margin-inline-start: 5px !important;
      margin-inline-end: -1px !important;
    }
  }
}
</style>
